import { LOG_PROPOSAL_TERMS_VIEW_API_ROUTE } from '~/routes/remix-api.log-proposal-terms-view';

/**
 * Fire-and-forget log when a customer opens terms and conditions on the proposal page.
 */
export function logProposalTermsView(
    invoiceId: number,
    termTitle?: string,
): void {
    if (invoiceId <= 0) {
        return;
    }

    const formData = new FormData();
    formData.append('invoiceId', String(invoiceId));
    if (termTitle) {
        formData.append('termTitle', termTitle);
    }

    void fetch(LOG_PROPOSAL_TERMS_VIEW_API_ROUTE, {
        method: 'POST',
        body: formData,
    });
}
